/** The size of the cover in the song page cover field, in CSS px. imgproxy makes the picture for it. */
export const SONG_COVER_FIELD_PX = 240;
